import { sharedHelper } from '@/utils'
import { SHARED_CLOSE_DIALOG, SHARED_LOADING, SHARED_SHOW_DIALOG, SHARED_UNLOADING } from './shared.module'
import { aiApplicationService } from '@/services'
import router from '@/router'
import { ROUTE_NAME } from '@/constants'
import moment from 'moment'

//define module name
const MODULE_NAME = 'aiApplication/'

//define actions name
const A_LIST = 'getAIApplicationListing'
const A_LIST_RESET = 'resetAIApplicationListing'
const A_HISTORY = 'getApplicationHistory'
const A_CREATE = 'createAIApplication'
const A_DETAILS = 'getAIApplicationDetails'
const A_HISTORY_DETAILS = 'getAIApplicationHistoryDetails'
const A_EDIT = 'editAIApplication'
const A_DUPLICATE = 'duplicateAIApplication'
const A_DETAILS_RESET = 'resetAIApplicationDetails'

//define dispatch action
export const AI_APPLICATION_LIST = MODULE_NAME + A_LIST
export const AI_APPLICATION_LIST_RESET = MODULE_NAME + A_LIST_RESET
export const AI_APPLICATION_HISTORY = MODULE_NAME + A_HISTORY
export const AI_APPLICATION_HISTORY_DETAILS = MODULE_NAME + A_HISTORY_DETAILS
export const AI_APPLICATION_CREATE = MODULE_NAME + A_CREATE
export const AI_APPLICATION_DETAILS = MODULE_NAME + A_DETAILS
export const AI_APPLICATION_EDIT = MODULE_NAME + A_EDIT
export const AI_APPLICATION_DUPLICATE = MODULE_NAME + A_DUPLICATE
export const AI_APPLICATION_DETAILS_RESET = MODULE_NAME + A_DETAILS_RESET

//define mutations name
const M_LIST = 'setAIApplicationListing'
const M_LIST_RESET = 'resetAIApplicationListingData'
const M_HISTORY = 'setApplicationHistory'
const M_DETAILS = 'setAIApplicationDetails'
const M_DETAILS_RESET = 'resetAIApplicationDetails'
const M_HISTORY_DETAILS = 'setAIApplicationHistoryDetails'
const M_HISTORY_DETAILS_RESET = 'resetAIApplicationHistoryDetails'

//init app state
const state = {
  list: {
    data: [],
    total: 0,
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  history: {
    data: [],
    total: 0,
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  details: {
    id: '',
    code: '',
    name: '',
    nric: '',
    phone: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    postcode: '',
    state: '',
    country: '',
    applicationDate: null,
    aiStatus: '',
    user: '',
    product: '',
    tiktokAccount: '',
    avatar: '',
    pc: '',
    referenceNumber: '',
    remarks: '',
    serviceStartDate: null,
    serviceEndDate: null,
    totalPrice: null,
    parentApplication: null,
    paymentDate: ''
  },
  historydetails: {
    id: '',
    code: '',
    name: '',
    nric: '',
    phone: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    postcode: '',
    state: '',
    country: '',
    applicationDate: null,
    aiStatus: '',
    user: '',
    product: '',
    tiktokAccount: '',
    avatar: '',
    pc: '',
    referenceNumber: '',
    remarks: '',
    serviceStartDate: null,
    serviceEndDate: null,
    totalPrice: null,
    paymentDate: '',
    parentApplication: null
  }
}

//to retrieve data from store state (called by component)
const getters = {}

const actions = {
  [A_LIST]({ dispatch, commit }, { filter }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.getAllAIApplications(filter).then(
      (result) => {
        commit(M_LIST, result)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_HISTORY]({ dispatch, commit }, { filter }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.getAllAIApplications({ ...filter, aiStatus: 'COMPLETED' }).then(
      (result) => {
        commit(M_HISTORY, result)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_CREATE]({ commit, dispatch }, { data }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.createAIApplication(data).then(
      () => {
        let successAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
          router.push({ name: ROUTE_NAME.AI_APPLICATION_LIST })
        }
        let messageDialog = sharedHelper.getRecordCreatedDialog(successAction)

        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_DETAILS]({ commit, dispatch }, { id }) {
    commit(M_DETAILS_RESET)
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.getAIApplication(id).then(
      (result) => {
        commit(M_DETAILS, result)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_HISTORY_DETAILS]({ commit, dispatch }, { id }) {
    commit(M_HISTORY_DETAILS_RESET)
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.getAIApplication(id).then(
      (result) => {
        commit(M_HISTORY_DETAILS, result)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_EDIT]({ commit, dispatch }, { id, data }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.editAIApplication(id, data).then(
      () => {
        let successAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
          router.push({ name: ROUTE_NAME.AI_APPLICATION_LIST })
        }
        let messageDialog = sharedHelper.getRecordUpdatedDialog(successAction)

        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_LIST_RESET]({ dispatch, commit }) {
    commit(M_LIST_RESET)
  },
  [A_DUPLICATE]({ commit, dispatch }, { id }) {
    commit(M_DETAILS_RESET)
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    aiApplicationService.getAIApplication(id).then(
      (result) => {
        commit(M_DETAILS, { ...result, isDuplicate: true })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      (error) => {
        let closeAction = () => {
          dispatch(`${SHARED_CLOSE_DIALOG}`, messageDialog, { root: true })
        }
        let messageDialog = sharedHelper.getErrorMessageDialog(error, closeAction)
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        dispatch(`${SHARED_SHOW_DIALOG}`, messageDialog, { root: true })
      }
    )
  },
  [A_DETAILS_RESET]({ commit }) {
    commit(M_DETAILS_RESET)
  }
}

const mutations = {
  [M_LIST](state, data) {
    let d = data
    let e = d.data
    state.list.data = []

    //process details
    for (let i = 0; i < e.length; i++) {
      let r = {
        id: e[i].id,
        applicationDate: moment(e[i].applicationDate).format('DD-MM-YYYY'),
        user: e[i].user ? e[i].user.code : '',
        name: e[i].customerName,
        referenceNumber: e[i].referenceNumber,
        product: e[i].product ? e[i].product.name : null,
        aiStatus: e[i].aiStatus.name,
        parentApplication: e[i].parentApplication ? { id: e[i].parentApplication.id, code: e[i].parentApplication.code } : { id: null, code: '' }
      }

      if (r.aiStatus != 'Completed') {
        state.list.data.push(r)
      }
    }
  },
  [M_HISTORY](state, data) {
    let d = data
    state.history.data = []

    //process details
    const history = d.data.map((item) => {
      return {
        id: item.id,
        applicationDate: moment(item.applicationDate).format('DD-MM-YYYY'),
        user: item.user ? item.user.code : '',
        name: item.customerName,
        referenceNumber: item.referenceNumber,
        product: item.product ? item.product.name : null,
        aiStatus: item.aiStatus.name,
        parentApplication: item.parentApplication ? { id: item.parentApplication.id, code: item.parentApplication.code } : { id: null, code: '' }
      }
    })

    state.history.data = [...state.history.data, ...history]
  },
  [M_LIST_RESET](state) {
    state.list = {
      data: [],
      total: 0,
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        lastPage: 0,
        tableRowsCount: 0
      }
    }
  },
  [M_DETAILS](state, data) {
    let d = data
    if (data.isDuplicate) {
      d.code = ''
      d.applicationDate = null
      d.referenceNumber = ''
      d.remarks = ''
      d.aiStatus = { id: 1 }
      d.product = null
      d.paymentDate = null
      d.rejectedReason = null
    }

    state.details = {
      ...state.details,
      id: d.id,
      applicationID: d.code,
      name: d.customerName,
      nric: d.nric,
      phone: d.phone,
      email: d.email,
      addressLine1: d.addressLine1,
      addressLine2: d.addressLine2,
      addressLine3: d.addressLine3,
      city: d.city,
      postcode: d.postcode,
      state: d.state.id,
      country: d.country.id,
      applicationDate: d.applicationDate,
      aiStatus: d.aiStatus ? d.aiStatus.id : null,
      user: d.user ? d.user.id : null,
      product: d.product ? d.product.id : null,
      tiktokAccount: d.tiktokAccount,
      avatar: d.avatar,
      pc: d.pc,
      referenceNumber: d.referenceNumber,
      remarks: d.remarks,
      serviceStartDate: d.serviceStartDate,
      serviceEndDate: d.serviceEndDate,
      totalPrice: d.totalPrice,
      paymentDate: d.paymentDate,
      duplicatedFrom: d.duplicatedFrom ?? null
    }
  },
  [M_DETAILS_RESET](state) {
    state.details = {
      ...state.details,
      id: '',
      code: '',
      name: '',
      nric: '',
      phone: '',
      email: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      postalCode: '',
      state: '',
      country: 1,
      applicationDate: null,
      aiStatus: 1,
      user: '',
      product: '',
      tiktokAccount: '',
      avatar: '',
      pc: '',
      referenceNumber: '',
      remarks: '',
      serviceStartDate: null,
      serviceEndDate: null,
      totalPrice: null,
      paymentDate: '',
      duplicatedFrom: null
    }
  },
  [M_HISTORY_DETAILS](state, data) {
    let d = data

    state.historydetails = {
      ...state.historydetails,
      id: d.id,
      applicationID: d.code,
      name: d.customerName,
      nric: d.nric,
      phone: d.phone,
      email: d.email,
      addressLine1: d.addressLine1,
      addressLine2: d.addressLine2,
      addressLine3: d.addressLine3,
      city: d.city,
      postcode: d.postcode,
      state: d.state.id,
      country: d.country.id,
      applicationDate: d.applicationDate,
      aiStatus: d.aiStatus,
      user: d.user ? d.user.id : null,
      product: d.product ? d.product.id : null,
      tiktokAccount: d.tiktokAccount,
      avatar: d.avatar,
      pc: d.pc,
      referenceNumber: d.referenceNumber,
      remarks: d.remarks,
      serviceStartDate: d.serviceStartDate,
      serviceEndDate: d.serviceEndDate,
      totalPrice: d.totalPrice,
      paymentDate: d.paymentDate
    }
  },
  [M_HISTORY_DETAILS_RESET](state) {
    state.historydetails = {
      id: '',
      code: '',
      name: '',
      nric: '',
      phone: '',
      email: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      postcode: '',
      state: '',
      country: '',
      applicationDate: null,
      aiStatus: '',
      user: '',
      product: '',
      tiktokAccount: '',
      avatar: '',
      pc: '',
      referenceNumber: '',
      remarks: '',
      serviceStartDate: null,
      serviceEndDate: null,
      totalPrice: null,
      paymentDate: ''
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
